import * as React from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';

export interface NullableTextFieldProps {
  defaultValue: string | null;
  onChange: (value: string | null) => void;
  value?: undefined;
}

// take all the props of TextFieldProps that we did not override
// partial is needed or TS expects you to provide all the ones that can be undefined as well
// this is needed because defaultValue is string | null, and TextFieldProps has string
type NonNullableTextFieldProps = Partial<Pick<TextFieldProps, Exclude<keyof TextFieldProps, keyof NullableTextFieldProps>>>;

export type _NullableTextFieldProps = NonNullableTextFieldProps & NullableTextFieldProps;

function initialValue(value: string | null) {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  return value;
}

// variant typing is broken apparently, so need to extract it and type cast it
const NullableTextField: React.FC<_NullableTextFieldProps> = ({ defaultValue, onChange, value, variant, ...rest }) => {
  const initializedValue = initialValue(defaultValue);

  const handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const val = evt.target.value;
    const nullableValue = val ? val : null;
    onChange(nullableValue);
  };

  return <TextField defaultValue={initializedValue} onChange={handleChange} variant={variant as 'outlined'} {...rest} />;
};

export default NullableTextField;
